import Accordion from 'components/Accordion';
import Button from 'components/Button';
import Field from 'components/Form/Field';
import FormResult from 'components/Form/FormResult';
import SectionHeader from 'components/SectionHeader';
import {useCancelSendByPost} from 'pages/History/SendingOrders/Details/services';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {t} from 'ttag';
import {onApiError} from 'utils/request-axios/utils';

type SendViaPostStatusProps = {
    isCancellable: boolean;
    isSelected: boolean;
    statusDescription: string;
    supersendMid: string;
};

const SendViaPostStatus: FC<SendViaPostStatusProps> = ({
    isCancellable,
    isSelected,
    statusDescription,
    supersendMid,
}) => {
    const methods = useForm();
    const apiCancelSendByPost = useCancelSendByPost();

    if (!isSelected) {
        return null;
    }

    const handleCancelSendByPost = async () => {
        await apiCancelSendByPost
            .mutateAsync({mid: supersendMid})
            .catch(onApiError(methods));
    };

    return (
        <FormProvider {...methods}>
            <div className="flex flex-col gap-4">
                <SectionHeader level={2} title={t`Send by Post`} />{' '}
                <Accordion
                    hasBorderWhenExpanded={false}
                    header={t`Status`}
                    isOpenByDefault={true}
                >
                    <div className="flex flex-col gap-4">
                        <div aria-label="Status for Send by Post">
                            {statusDescription}
                        </div>
                        {isCancellable && (
                            <>
                                <Field type="value">
                                    <Button
                                        className="w-min"
                                        kind="destructive"
                                        onClick={handleCancelSendByPost}
                                    >
                                        {t`Cancel Sending by Japan Post`}
                                    </Button>
                                </Field>
                                <FormResult />
                            </>
                        )}
                    </div>
                </Accordion>
            </div>
        </FormProvider>
    );
};
export default SendViaPostStatus;
